import { useAppStateStore } from "@/features/application"
import { registerPopupAuto } from "@/features/application/popup-auto/PopupAuto"
import { TypesContextesAutorisesEnum } from "@/features/auth/context-app"
import { useDemandeRattachement } from "./useDemandeRattachement"

export function registerPopupAutoRattachement() {
  registerPopupAuto({
    key: "RATTACHEMENT",
    once: true,
    canPopup: async () => {
      // Ne pas poper si pas de rattachement
      const appState = useAppStateStore()
      return appState.estUtilisateurAuthentifie
        && appState.estAuthentificationEnCours === false
        && appState.estUtilisateurImpersonnalise === false
        && appState.contextCourant === TypesContextesAutorisesEnum.Aucun
    },
    showPopup: () => {
      const dialogDemandeRattachement = useDemandeRattachement()
      return dialogDemandeRattachement.showDialog().catch(() => { })
    }
  })
}
